import { RowState } from "./enums";
export class EntityBase {
  Id: number;
  TenantId?: number;
  BranchId?: number;
  BrandId?: number;
  State?: RowState;
  CreatedUserId?: number;
  ModifiedUserId?: number;
  ModifiedDate?: Date;
  CreatedDate?: Date;
}

export class GridColumnInfo extends EntityBase {
  public Key: string;
  public ColumnInfo: string;
  public Group: string;
}
export class GridColumnInfoDetail {
  public name: string;
  public orderindex: number;
  public leaftindex: number;
  public hidden: boolean;
  public width: number;
  public minResizableWidth: number;
  public title: string;
}
